import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button, ButtonGroup, FormControl, Tooltip } from '@mui/material';
import { React, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ColorConstants from '../../../defaults/ColorConstants';
import FieldNames from '../../../defaults/FieldNames.json';
import { useIFPRSGlobalContext } from '../../../IFPRSGlobalContext';
import LookupService from '../../../services/LookupService';
import { StyledAddSetButton, StyledSetHeaderRow } from '../containers/Set-styled';
import PlusIcon from '../icons/PlusIcon';
import CustomFilterExpressions from './CustomFilterExpressions';

const theme = createTheme({
  overrides: {
    
  },
});

const Set = ({id, fields, mustMatchAll, expressions, disableUnique, updateExpression, updateSetOperator, 
  removeSet, addExpression, removeExpression, overrideStringOperators, userInfo, datasetSelection }) => {
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
  const { statusOptions, setStatusOptions } = useIFPRSGlobalContext();
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);

  useEffect(() => {
    if(rootServiceUrl && config){
      if(!statusOptions || (statusOptions && statusOptions.length === 0)){
        LookupService.getStatuses(false).then(response => {
          if(response && response.length > 0){
            const statusNames = response.map(x => x[FieldNames.statusTable.status]);
            setStatusOptions(statusNames);
          }
        });
      }
    } 
  }, [rootServiceUrl, config, statusOptions, setStatusOptions]);

  const handleAddExpression = () => {
    addExpression(id);
  };

  const handleRemoveSet = () => {
    removeSet(id);
  };

  const handleUpdateSetOperator = mustMatchAll => {
    updateSetOperator(id, mustMatchAll);
  };

  const handleRemoveExpression = expressionId => {
    removeExpression(id, expressionId);
  };

  const handleUpdateExpression = expression => {
    updateExpression(id, expression);
  };

  const removeSetButton = () => {
    return (
      <FormControl style={{ margin: 0 }}>
        <Button xs={1} onClick={handleRemoveSet}>
          Remove Set
        </Button>
      </FormControl>
    )
  }

  return (
    <div style={{ border: `1px solid ${ColorConstants.LessLightGrayAlien}`, borderRadius: 5, padding: 10, backgroundColor: `${ColorConstants.LightGrayAlien}` }}>
      <ThemeProvider theme={theme}>
      <StyledSetHeaderRow>
        <FormControl style={{ marginBottom: '5px', display: 'flex', flexDirection: 'row' }}>
          <label style={{ marginRight: '10px' }}>
            Set Operator:
          </label>
          <ButtonGroup>
            <Tooltip title="All Expressions Match" enterDelay={400}>
              <Button
                xs={1}
                variant={ mustMatchAll ? "contained" : "outlined" }
                // clear={!mustMatchAll}
                onClick={() => handleUpdateSetOperator(true)}
              >
                AND
              </Button>
            </Tooltip>
            <Tooltip title="Any Expressions Match" enterDelay={400}>
              <Button
                xs={1}
                variant={ !mustMatchAll ? "contained" : "outlined" }
                // clear={mustMatchAll}
                onClick={() => handleUpdateSetOperator(false)}
              >
                OR
              </Button>
            </Tooltip>
          </ButtonGroup>
        </FormControl>
        {removeSetButton}
      </StyledSetHeaderRow>
      <CustomFilterExpressions 
        expressions={expressions} 
        fields={fields} 
        disableUnique={disableUnique} 
        overrideStringOperators={overrideStringOperators} 
        handleUpdateExpression={handleUpdateExpression}
        handleRemoveExpression={handleRemoveExpression} 
        statusOptions={statusOptions} 
        isDropdownLoading={isDropdownLoading} 
        setIsDropdownLoading={setIsDropdownLoading} 
        userInfo={userInfo}
        datasetSelection={datasetSelection}
      />
      <StyledAddSetButton onClick={handleAddExpression}>
        <PlusIcon fill={theme.palette.gray} /> Add Expression
      </StyledAddSetButton>
      </ThemeProvider>
    </div>
  );
};

export default Set;